import React from 'react';
import { useContext } from 'react';
import SimpleContext from './../context/SimpleContext';
import Date from './../Date/Date';

const TahvilDate = () => {

    const context = useContext(SimpleContext);
    const tarikh = context.tarikhTahvilKala;

    return ( 

        <>
            <div className="productsmain" style={{backgroundColor:"#f2f2f2"}}>    
                <div className="otherPagesHeader">
                    <div className="barbuttonn">
                        <img src="images/Api.png" className="apiLogoHeaders" alt=""/>
                    </div>
                    <div className="headersNames">
                        <p style={{margin:"0"}}>مشخصات کاربر</p>
                    </div>
                    <div className="pt-2">
                        <p style={{marginTop:"3%", fontSize:"13px"}}>
                            <Date/>
                        </p>
                    </div>
                </div>

                <div className="TahvilMain text-center">
                    
                    <p style={{fontSize:"12px"}} className="mt-2">زنجان</p>
                    
                    <div>
                        <hr style={{width:"312px"}} />
                        <img className="regimg" src="./images/truck_animation.gif" alt="ApiLogo" />
                        <hr style={{width:"312px"}} />
                    </div>
                    
                    <div style={{width:"100%"}}
                    className="text-center mr-3">
                        <p>درصورتی که امروز سفارش خود را ثبت کنید:<br/>موعد تحویل بار<br/> {tarikh}میباشد<br/><br/><br/>هزینه ارسال رایگان میباشد.</p>
                    </div>
                                
                </div>
            </div>
        </>
     );
}
 
export default TahvilDate;